"use client";

import { useDictionary } from "../context/dictionaryProvider";
import { ContentContainer } from "./molecules";

const NoResults = () => {
  const dict = useDictionary();
  return (
    <ContentContainer>
    <div className="flex items-center justify-center h-full border-small rounded-md py-10 my-10 max-h-64">
      <div className="text-center">
        <h2 className="text-lg font-medium text-gray-900">
          {dict?.noResult?.title}
        </h2>
        <p className="text-gray-600">{dict?.noResult?.description}</p>
      </div>
    </div>
    </ContentContainer>
  );
};

export default NoResults;
